/**
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *  PODPOWIEDŹ NAZWY PLIKU ZDJĘCIA — „Nr u dostawcy" plus rozszerzenie wybranego pliku.
 *
 *  ⚠️⚠️ DECYZJA UŻYTKOWNIKA Z 24.09.2026: „podpowiadać z Nr u dostawcy". Zmierzone na DBW
 *  14.08.2026: 42 z 48 towarów mają zdjęcie nazwane dokładnie tym numerem (`P0297445.jpg`), a pole
 *  „Nazwa pliku w SPS" z długim opisem o indeksie dostawcy było jednym z powodów zgłoszeń, że
 *  wgrywanie jest trudne. Człowiek nadal może nazwę zmienić — to podpowiedź, nie reguła.
 *
 *  ⚠️ TO SAMO SITO, CO NA SERWERZE (`NAZWA_OBRAZKA` w `items.dto.ts`): litery, cyfry, kropka,
 *  myślnik i podkreślenie, na początku litera albo cyfra. Numer dostawcy ze spacją albo ukośnikiem
 *  dałby inaczej odmowę dopiero po kliknięciu „Wyślij", a plik z dysku bywa „IMG 1234.JPG".
 *
 *  ⚠️ ROZSZERZENIE Z NAZWY PLIKU jest tylko zgadywaniem — serwer poprawia je z TREŚCI pliku i mówi
 *  o tym (`poprawionoZ`), więc tu wystarczy rozsądny domysł.
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 */
const ROZSZERZENIE = /\.(jpe?g|png|bmp|gif)$/i;

/** Rozszerzenie wybranego pliku małymi literami; nierozpoznane → `.jpg`. */
export function rozszerzenie(nazwa: string): string {
  const m = ROZSZERZENIE.exec(nazwa.trim());
  return m === null ? '.jpg' : `.${m[1]!.toLowerCase()}`;
}

/** Rdzeń nazwy przez sito serwera — `''`, gdy nic z niego nie zostało. */
export function bezpiecznyRdzen(napis: string): string {
  return napis
    .trim()
    .replace(/[^A-Za-z0-9._-]+/g, '_')
    .replace(/^[^A-Za-z0-9]+/, '')
    .replace(/[._-]+$/, '');
}

export function podpowiedzNazwy(nrUDostawcy: string | null | undefined, plikZDysku: string): string {
  const nr = (nrUDostawcy ?? '').trim();
  /** ⚠️ Numer, który już jest nazwą pliku (`P0496.jpg`), zostaje — inaczej wyszłoby `P0496.jpg.jpg`. */
  if (nr !== '' && ROZSZERZENIE.test(nr)) {
    const rdzen = bezpiecznyRdzen(nr.replace(ROZSZERZENIE, ''));
    if (rdzen !== '') return `${rdzen}${rozszerzenie(nr)}`;
  }
  const rdzenNr = bezpiecznyRdzen(nr);
  if (rdzenNr !== '') return `${rdzenNr}${rozszerzenie(plikZDysku)}`;
  const rdzenPliku = bezpiecznyRdzen(plikZDysku.replace(ROZSZERZENIE, ''));
  return `${rdzenPliku === '' ? 'zdjecie' : rdzenPliku}${rozszerzenie(plikZDysku)}`;
}
